import { ERoutes } from "@/constants/routes";

const BRAND_CARD_HASH_PREFIX = "brand-card-";

export type BrandsChartOpenIntent = {
  shouldOpen: boolean;
  brandId: number | null;
};

/** DOM id for a brand card (used for scroll-into-view and URL hash). */
export function getBrandCardElementId(brandId: number): string {
  return `${BRAND_CARD_HASH_PREFIX}${brandId}`;
}

/**
 * Parses brand id from location hash (`#brand-card-123`).
 */
export function parseBrandIdFromHash(hash: string): number | null {
  const normalized = hash.replace(/^#/, "");
  if (!normalized.startsWith(BRAND_CARD_HASH_PREFIX)) {
    return null;
  }

  const brandId = Number(normalized.slice(BRAND_CARD_HASH_PREFIX.length));
  if (!Number.isFinite(brandId) || brandId <= 0) {
    return null;
  }

  return brandId;
}

/**
 * Builds Brands page URL: hash selects the brand, opens its chart, and scrolls into view.
 */
export function buildBrandsWithChartOpenRoute(brandId: number): string {
  return `${ERoutes.Brands}#${getBrandCardElementId(brandId)}`;
}

/**
 * Parses chart-open intent from location hash.
 */
export function parseBrandsChartOpenIntent(hash: string): BrandsChartOpenIntent {
  const brandId = parseBrandIdFromHash(hash);
  if (brandId == null) {
    return { shouldOpen: false, brandId: null };
  }

  return { shouldOpen: true, brandId };
}
